import 'reflect-metadata';

import { IntlProvider } from 'react-intl';
import Intl from 'intl';
import { translations } from '@I18n/translations';
import { defaultLocale } from '@I18n/default';
import * as React from 'react';

global.Intl = Intl;

const TranslationProvider: React.FC<React.PropsWithChildren> = ({ children }) => {

  // set locale and messages for IntlProvider.
  const locale = document.documentElement.lang || defaultLocale;
  // @ts-ignore
  const messages = translations[locale];

  return (
    <IntlProvider locale={locale} defaultLocale={defaultLocale} key={locale} messages={messages}>
      {children}
    </IntlProvider>
  );
};

export default TranslationProvider;
